var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-table',{ref:"table",attrs:{"api-builder":_vm.apiBuilder,"columns":_vm.columns,"row-actions":['edit', 'delete'],"bulk-actions":[],"search-fields":null,"on-edit-item":_vm.editing}})}
var staticRenderFns = []

export { render, staticRenderFns }